import React, { useEffect } from "react";

/*


Front page products

import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';

*/

import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  IconButton,
} from "@material-ui/core";
//icon
import { AddShoppingCart } from "@material-ui/icons";
//
import arrowLong from "../../../lib/arrow2.svg";

// import { CgArrowLongRight } from "react-icons/cg";
//https://react-icons.github.io/react-icons/search?q=arrow

//styles HOOK
import useStyles from "./styles";
import Aos from "aos";
import "aos/dist/aos.css";
// zoom in related
//
const Product = ({ product, onAddToCart }) => {
  //  styles HOOK
  const classes = useStyles();
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //

  return (
    <>
      <Card className={classes.root}>
        <CardMedia
          className={classes.media}
          image={product.image.url}
          title={product.name}
          // data-aos="fade-up-right"
        />
        <CardContent>
          <div className={classes.cardContent}>
            <Typography
              gutterBottom
              variant="h5"
              className={classes.productName}
            >
              {product.name}
            </Typography>
            {/* price */}
            <Typography
              gutterBottom
              variant="h5"
              className={classes.productPrice}
            >
              {product.price.formatted_with_symbol}
            </Typography>
          </div>
        </CardContent>
        {/* 
        
        CardActions  */}
        <div className={classes.wrapperCardActions}>
          {" "}
          <CardActions disableSpacing className={classes.cardActions}>
            {/* DESCRIPTION */}
            <Typography
              dangerouslySetInnerHTML={{ __html: product.description }}
              variant="body2"
              color="textSecondary"
              className={classes.DescriptionComp}
            />
            {/* 
          
           */}

            <div className={classes.svgProductContainer}>
              <img className={classes.svgBox} src={arrowLong} alt="" />
            </div>

            {/* 
        
           */}
            {/* ICON BUTTON ON CLICK */}

            <IconButton
              className={classes.IconAddToCartActions}
              aria-label="Add to Cart"
              onClick={() => onAddToCart(product.id, 1)}
            >
              <AddShoppingCart className={classes.TheIconAddToCart} />
            </IconButton>
          </CardActions>
        </div>
      </Card>
    </>
  );
};

export default Product;
